const uploadPool = store => {
  store.on("@init", () => ({ uploadPool: {} }));
  store.on("uploadPool/setProgress", ({ uploadPool }, { file, progress }) => {
    uploadPool[file] = progress;
    return { uploadPool };
  });
};

export default uploadPool;
